module.exports = __webpack_public_path__ + "static/image/audience-guide2.svg?8756ce93ed0f2cec454f9068e65a0e1f";